<template>
    <div class="alert alert-dismissible fade show" :class="'alert-' + type" role="alert">
        <div class="d-flex align-items-center">
            <svg
                :width="iconSize"
                :height="iconSize"
                fill="currentColor"
                class="me-2"
                v-if="showIcon"
            >
                <use :xlink:href="'/assets/icons/bootstrap-icons.svg#' + icon" />
            </svg>
            <div v-html="body"></div>
        </div>

        <!-- <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="x"></button> -->
    </div>
</template>

<script>
    export default {
        name: 'AlertElement',
        props: {
            type: {
                type: String,
                default: "light",
            },
            showIcon: {
                type: Boolean,
                default: true,
            },
            icon: {
                type: String,
                default: "info-circle",
            },
            iconSize: {
                type: Number,
                default: 20,
            },
            body: {
                type: String,
                default: "",
            },
        },
        setup() {},
    };
</script>